import {
  createRouter,
  createWebHistory,
  createWebHashHistory,
} from "vue-router";
import HomeView from "../views/HomeView.vue";
import HomeView2 from "../views/HomeView2.vue";
// import HomeView from "../views/home.vue";
// import about from "../views/about.vue";
// import detail from "../views/detail.vue";
// import HomeView from "../views/HomeView.vue";

import SucaiDetail from "@/views/SucaiDetail.vue";
import CopyrightCenter from "@/views/CopyrightCenter.vue";
const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    meta: { keepAlive: true },
  },
  {
    path: "/home2",
    name: "home2",
    component: HomeView2,
    meta: {},
  },
  { path: "/sucaiDetail", component: SucaiDetail },
  {
    path: "/copyright",
    name: "copyright",
    component: CopyrightCenter,
    meta: {},
  },
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { top: 0, left: 0 };
  },
});

export default router;
